var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "history" }, [
    _vm.items
      ? _c("div", { staticClass: "align-center text-right" }, [
          _c(
            "div",
            { staticClass: "d-flex justify-end" },
            [
              _vm._t("buttons", null, {
                rows: _vm.rows,
                titles: _vm.titles,
                setRows: _vm.setRows,
              }),
              _c(
                "v-btn",
                {
                  staticClass: "mb-2",
                  attrs: {
                    disabled: !_vm.mappingsSelected || !_vm.dataChanged,
                    color: "primary",
                    elevation: "0",
                  },
                  on: { click: _vm.apply },
                },
                [_vm._v("Сохранить")]
              ),
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "d-flex justify-end align-center mb-4" },
            [
              _c("v-spacer"),
              _c("v-text-field", {
                attrs: {
                  type: "number",
                  label: "Время",
                  hint: "Добавить или удалить время",
                  "persistent-hint": "",
                },
                model: {
                  value: _vm.changeTime,
                  callback: function ($$v) {
                    _vm.changeTime = $$v
                  },
                  expression: "changeTime",
                },
              }),
              _c(
                "v-btn",
                { attrs: { icon: "", color: "primary" } },
                [
                  _c("v-icon", { on: { click: _vm.deleteTime } }, [
                    _vm._v("mdi-delete"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ])
      : _vm._e(),
    _c("div", { staticClass: "history-table" }, [
      _c(
        "div",
        { staticClass: "history-table__container" },
        [
          _vm.rows
            ? _c(
                "vue-excel-editor",
                {
                  attrs: {
                    "no-paging": "",
                    "enter-to-south": "",
                    "no-header-edit": false,
                    "no-footer": "",
                    "record-label": function (recordPosition, record) {
                      return recordPosition - 1 + "/" + record.t
                    },
                  },
                  model: {
                    value: _vm.rows,
                    callback: function ($$v) {
                      _vm.rows = $$v
                    },
                    expression: "rows",
                  },
                },
                _vm._l(_vm.titles, function (key) {
                  return _c("vue-excel-column", {
                    key: key,
                    attrs: {
                      field: key,
                      label: key,
                      type: "number",
                      invisible: key === "t",
                    },
                  })
                }),
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }